module.exports = __webpack_public_path__ + "static/img/big-icon-1.5105a25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/big-icon-1.png
// module id = X7BU
// module chunks = 85